import { ROUTES } from '@dashboard/router/routeNames'

export default [
  {
    name: ROUTES.TEMPLATES,
    path: 'templates',
    component: () => import('./pages/TemplatesIndex.vue'),
    meta: {
      title: 'Templates',
      description: 'Get started segmenting your audience and personalizing your marketing using our templates.'
    }
  },
  {
    name: ROUTES.TEMPLATE,
    path: 'templates/:templateId',
    component: () => import('./pages/TemplateShow.vue'),
    meta: { fullScreen: true }
  }
]
